// NOTE: Prism should always be the first import in this file
import Prism from 'prismjs';
import 'prismjs/plugins/autoloader/prism-autoloader';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import { prefixStaticAsset } from '@aurora/shared-utils/helpers/urls/UrlHelper/UrlHelper';
import hashes from '@aurora/shared-generated/static-hashes.json';

if (Prism && Prism.plugins && Prism.plugins.autoloader) {
  Prism.plugins.autoloader.languages_path = prefixStaticAsset(
    `/rte/prismjs/${hashes.prism}/components/`
  );
}

// eslint-disable-next-line unicorn/prefer-export-from
export default Prism;
